export enum LockAccessCodeType {
  AUTOMATIC = 'Automatic',
  MANUAL = 'Manual',
}

export enum LockAccessCodeStatus {
  ACTIVE = 'ACTIVE',
  FUTURE = 'FUTURE',
  EXPIRED = 'EXPIRED',
}
